import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import { bootstrapApplication } from '@angular/platform-browser';
import { loadRuntimeConfig } from '@seatix/shared-config';
import { readAuthTransfer } from '@seatix/shared/auth/utils';
import { initializeSentry } from '@seatix/shared-util-error-tracking';
import { DeferredStyleLoaderService } from '@seatix/shared/utils';
import { AppComponent } from './app/app.component';
import { createAppConfig } from './app/app.config';

const release = `${process.env['STX_APP_ID']}@${process.env['STX_APP_VERSION']}`;
const checkoutUrl = process.env['STX_CHECKOUT_URL'];
const allowUrls = checkoutUrl ? [checkoutUrl] : [];

// Adopt the session handed off by fan-portal (via the `auth_transfer` param)
// before AuthStore is constructed, so it wins over any stale localStorage.
readAuthTransfer();

initializeSentry({
  applicationKey: process.env['STX_APP_ID'] as string,
  dsn: process.env['STX_SENTRY_DSN_CHECKOUT'] as string,
  environment: process.env['STX_ENVIRONMENT'] as string,
  release,
  tracesSampleRate: process.env['STX_ENVIRONMENT'] === 'production' ? 0.1 : 1.0,
  debug: process.env['STX_ENVIRONMENT'] === 'development',
  enabled: process.env['STX_ENVIRONMENT'] !== 'development',
  tracePropagationTargets: ['localhost'],
  sendDefaultPii: true,
  dist: process.env['STX_BUILD_NUMBER'],
  integrations: {
    browserTracing: true,
    replay: true,
  },
  allowUrls,
});

registerLocaleData(localeEsMx);

loadRuntimeConfig(process.env['STX_CDN_URL']!).then((runtimeConfig) => {
  bootstrapApplication(AppComponent, createAppConfig(runtimeConfig))
    .then((appRef) => {
      const styleLoader = appRef.injector.get(DeferredStyleLoaderService);
      styleLoader.loadDeferredStyles();
    })
    .catch((err) => {
      console.error('Error initializing app:', err);
    });
});
